var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-text"},[_c('hr',{class:_vm.gold ? 'text-gold-500' : 'text-white'}),_vm._v(" "),_c('div',{staticClass:"text-base uppercase tracking-wide py-8"},[_vm._t("title-text")],2),_vm._v(" "),_c('div',{staticClass:"uppercase tracking-widest leading-normal"},[_vm._t("subtitle-text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }